export const socialsData = {
    instagram: 'https://www.instagram.com/drsimin_2',
    telegram: 'https://t.me/DrSiminTeam',
    bale: 'https://ble.ir/join/6jyeunoedz',
    linkedIn: '',
    youtube: '',
}
